import { createContext, useContext } from 'react';
const initialValues = {
    underFlyOutMenu: false,
    hasToggle: false,
};
const MenuContext = createContext(initialValues);
export default MenuContext;
export const useMenuContext = () => useContext(MenuContext);
//# sourceMappingURL=MenuContext.js.map